export const _LOAD_MODEL_ = 'Load:PuzzleTerm';
export const _NEW_MODEL_ = 'New:PuzzleTerm';
export const _SAVE_MODEL_ = 'Save:PuzzleTerm';
export const _DELETE_PUZZLE_ = 'Delete:PuzzleTerm';
export const _UPDATE_PUZZLE_PAGINATION_ = 'update:termPagination';

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  attempt: 3,
  word: '',
  letter: null,
  published_date: null,
};
